var React = require('react');

function UstaInfo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M8 15.5c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zM8 11.5v-4","key":0}),React.createElement("path",{"fill":"#737680","d":"M7.25 4.75c0-.415.335-.75.75-.75s.75.335.75.75-.335.75-.75.75-.75-.335-.75-.75z","key":1})]);
}

UstaInfo.defaultProps = {"width":"16","height":"17","fill":"none","viewBox":"0 0 16 17"};

module.exports = UstaInfo;

UstaInfo.default = UstaInfo;
